import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    HopIcon,
    Hand,
    Kanban,
    SkipBack,
    SkipForward,
    BadgeCheck,
    HandHelping} from 'lucide-react';

import SectionsQuizAddMore from "./SectionsQuizAddMore";
import CreateSectionPopUp from "./CreateSectionPopUp";
import { createNewMockTest,createNewMockSection,getSectionsByQuizId, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import Toggle from "../../../UI/Toggle";
import Snackbar from "../../../../Snackbar";
import SectionsQuizAddMoreLoading from "./SectionsQuizAddMoreLoading";

  
const SetSectionForQuestion= ({setHideSectionPopUp,parentID,quizObject,questionId,sendBackData})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
   const [goNextPopUp, setGoNextPopUp] =useState(false);
    const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
         const [deleteSectionPopUp, setDeleteSectionPopUp] = useState(false);
         const [deleteId, setDeleteId] = useState("");
            const [isLockSections, setIsLockSections] = useState();
      const [createNewSectionPopUp, setCreateNewSectionPopUp] = useState(false);
    // let allSections= allSectionsData
const [parentFolder, setParentFolder] = useState({ID:""});
    
        const [allSections, setAllSections] = useState([]);
       
        const [ visibility, setVisibility] = useState("public");
          
 const [itemArr, setItemArr] = useState(allSections);
 const [questionArr, setQuestionArr] = useState([]);
   let newSection= { no:1, id: generateTimestamp()
          ,title:"" ,sectionName:"",lockTime:10,questions:[] } ;
  
     useEffect(() => {
        
       
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
       
        fireGetSectionDataByQuizId()
        // setCourseTitleData();
      },[])
   


      const handleBack=(e)=>{
  
        setLoader({status:true});
        
        history.goBack();
        }
        
 
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.ID !== id);
        setItemArr(filteredItems);
        handleCreateNewSection("deleteItem","",id)
      };
      const updateItemtitle = (id, sectionName,sectionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, sectionName :sectionName } : item
        
        ); 
        
        setItemArr(updatedItems);
        handleCreateNewSection("sectionName",sectionName,sectionId)
       
      };
    

const updateItemSecQuestions = (ID, newSecQuestions, sectionId) => {
  const newQuestionIds = newSecQuestions?.map(q => q?.ID?.toString());

  setItemArr(prev => {
  const updated = prev.map(item => {
    let existingQuestions;

    try {
      existingQuestions = typeof item?.secQuestions === "string"
        ? JSON.parse(item.secQuestions)
        : item?.secQuestions || [];
    } catch (e) {
      console.error("Invalid secQuestions JSON:", e);
      existingQuestions = [];
    }

    if (item?.ID === ID) {
      const filteredExisting = existingQuestions.filter(
        q => !newQuestionIds.includes(q?.ID?.toString())
      );
      const mergedQuestions = [...filteredExisting, ...newSecQuestions];

      const mergedQuestionsWithStringId = mergedQuestions.map(q => ({
        ...q,
        ID: q.ID?.toString()
      }));

      handleCreateNewSection("secQuestions", mergedQuestionsWithStringId, sectionId);

      return {
        ...item,
        secQuestions: JSON.stringify(mergedQuestionsWithStringId)
      };
    } else {
      const filteredQuestions = existingQuestions.filter(
        q => !newQuestionIds.includes(q?.ID?.toString())
      );

      const filteredQuestionsWithStringId = filteredQuestions.map(q => ({
        ...q,
        ID: q.ID?.toString()
      }));

      handleCreateNewSection("secQuestions", filteredQuestionsWithStringId, item?.ID);

      return {
        ...item,
        secQuestions: JSON.stringify(filteredQuestionsWithStringId)
      };
    }
  });

  sendBackData(updated); // ✅ callback with updated state

  return updated; // ✅ must return new array
});



 
  

};
      const updateItemlockTime = (id, lockTime,sectionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, lockTime :lockTime } : item
        
        ); 
        
        setItemArr(updatedItems);
      
       handleCreateNewSection("lockTime",lockTime,sectionId)
      };
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
  }));
  setItemArr(reorderedItems);
  handleCreateNewSection("updateSections",reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   const fireGetSectionDataByQuizId=()=>{
   setItemArrLoading([{},{},{},{}])
    setLoader({status:true});
    
      const apiData = dispatch(getSectionsByQuizId({testName:"",type:"section",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            // console.log(response)
          if(response?.sections){
            setItemArrLoading([])
        setResponseMessage(response?.message);  
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         setItemArr( response?.sections?response?.sections:[])
         setQuestionArr(response?.sections?.secQuestions?response?.sections.secQuestions:[])

       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

     
  const handleCreateNewSection=(editType,val,sectionId)=>{
     let SendObject=""
     if(editType=="sectionName"){
        SendObject={sectionName:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
            
         if(editType=="lockTime"){
        SendObject={lockTime:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }  if(editType=="secQuestions"){
        SendObject={secQuestions:JSON.stringify(val),type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="deleteItem"){
        SendObject={visibility:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
            
            //   console.log(SendObject)
            
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockSection(SendObject));


       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
            console.log(response)
           if(response?.sections){
            if(editType=='sectionName'){
   if(sectionId==response?.sections?.ID){}else{setItemArr([...itemArr,response?.sections]); }
            }
            // else
            //  if(editType=='lockTime'){
            //     if(sectionId==response?.sections?.ID){}else{setItemArr([...itemArr,{...newSection,sectionName:response?.sections?.sectionName}]); }
            //  }
            //  if(editType=="allSections"){
            //  setItemArr( response?.quiz?.allSections?JSON.parse(response?.quiz?.allSections):[])
            //  }
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
     
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
   

       const isQuestionInSection = (item, questionId) => {
  return item?.secQuestions?JSON.parse(item?.secQuestions)?.some(q => q?.ID == questionId) || false:false;
};
     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
    <div > 
      <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:9999999999,cursor:"pointer"}} onClick={()=>{}} className="appDesignPopUpOpacity"> </div>
  
    <div  className="AreYouSurePopUpFour"style={{margin:"0px",zIndex:99999999999,border:"0px solid #ffffff",borderRadius:"25px"}}>
         {createNewSectionPopUp?<CreateSectionPopUp  sendBackData={(data)=>{   handleCreateNewSection("sectionName",data,"")}} closeSectionPopUp={()=>{ setCreateNewSectionPopUp(false);}} /> :""}
   <div style={{background:"rgba(86, 82, 131,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"10px",top:"10px",
                        alignContent:"center",textAlign:"center",padding:"5px",paddingTop:"6px",margin:"5px",zIndex:99999,cursor:"pointer"}} onClick={()=>setHideSectionPopUp()} ><X size={22}  color="rgb(86, 82, 131)"/></div> 
   <div style={{fontSize:"22px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",justifyContent:"center"}}>
           Select  <span className="coloredTextV1" > &nbsp;   Section</span> &nbsp;   For This Question</div>
               <div  className=" " style={{borderRadius:"25px",height:"83vh",overflowY:"auto"}}>
  <div  className=" " >
   
  
<div  className="gridForWhatsNextAfterYT2"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
{flattenedData&&flattenedData.length!==0?flattenedData.map((item, index) => 
        (<div  index={index} key={item.ID} 
          >
           
 <div 
   
   
   style={{padding:"5px",margin:"5px", marginTop:"10px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:isQuestionInSection(item, questionId)?"5px solid rgba(144, 202, 249,1)":"5px solid rgba(144, 202, 249,0.1)"}}> 
   
<div  style={{}}>
    
    <div>
    <div  style={{background:"#ffffff",borderRadius:"15px",marginTop:"10px",padding:"5px",}}> 
  
                         <div style={{background:"rgba(144, 202, 249,0.1)",borderRadius:"15px",border:"0px solid rgba(144, 202, 249,1)",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"left",gap:"15px"
            }}> 
     <div style={{textAlign:"left",paddingLeft:"10px",}}><h4>
      Section {index+1}</h4></div>
        {<div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}    className=""><h3 style={{paddingLeft:"10px",}}>{item?.sectionName}</h3></div>}
        
     
        
        </div><div style={{marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             
              transition: 'transform 2s ease, opacity 2s ease',display:"flex",justifyContent:"space-between"
            }}>
           {isLockSections?<div style={{display:"flex",justifyContent:"space-between",gap:"10px",paddingLeft:"5px"}}><div ><h4>
      Lock Time</h4></div><div ><h4>
      {item?.lockTime} Min </h4></div>
            
    </div>:<div></div>}
        <div  className=""style={{display:"flex",justifyContent:"space-between"}}>
        <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ 
                //  sendBackData("sectionObject",item)
updateItemSecQuestions (item?.ID, [{ID:questionId}], item?.ID) 

                 }}
               className="QuizAddSectionBtn" style={{background:isQuestionInSection(item, questionId)?"rgba(144, 202, 249,1)":"#ffffff",color:isQuestionInSection(item, questionId)?"#ffffff":"#555555",display:"flex",justifyContent:"space-between"}} > <div style={{}}>{isQuestionInSection(item, questionId)?<BadgeCheck  color={isQuestionInSection(item, questionId)?"#ffffff":"#555555"} size={20}/>:<ChevronLeft color={"#555"} size={20}/>}</div>  
               <div>{isQuestionInSection(item, questionId)?"Selected":"Select Section"}</div> </div>
                </div></div>
   <div style={{float:"right",padding:"15px"}}>
   
   
    </div> 
    
     
    
    </div>
    
    </div>
    
    </div>


          </div>
          
          </div>)):""}
        
  
   
    </div> 
      {flattenedDataLoading.length==0&&flattenedData.length==0? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",margin:"15px",display:"flex",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Section Found </div>:"" }
    <div  className="gridForWhatsNextAfterYT2"> 
     { flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index}    >
<SectionsQuizAddMoreLoading/></div>)):""}</div>
   <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Section </div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setCreateNewSectionPopUp(true);;   }}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div>    </div>  </div>  </div> 

  
      
                                    
     </>)  
   }
   export default SetSectionForQuestion;